import React, { memo, forwardRef, useState, useEffect} from 'react'
import { Form } from 'react-bootstrap'


const FormControl = forwardRef((props, ref) => {
    // passing the ref to a DOM element, 
    // so that the parent has a reference to the DOM node

    var control = <></>;
    const [value, setValue] = useState('');

    const handleChange = (event) =>  {
        setValue(event.target.value);
    }

    useEffect(() => {
        setValue(props.value);
      
    }, [props])

        control = <Form.Control ref={ref} defaultValue={value} onChange={handleChange} required={props && props.required} />;

        if(props.type && props.type === "textarea")
            control = <Form.Control defaultValue={value} onChange={handleChange} rows={props.rows} as={props &&  props.type} ref={ref} required={props && props.required} />;
        else if(props.type)
            control = <Form.Control defaultValue={value} step={props.step} onChange={handleChange} type={props &&  props.type} ref={ref} required={props && props.required} />;

    return (<Form.Group className={props.classes}>
                <Form.Label>{props.label}</Form.Label>
                {control}
            </Form.Group>)
         
  });
  
export default memo(FormControl);


